var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"math-container"},[_c('editor',{ref:"editor",attrs:{"answerHtml":_vm.answerHtml},on:{"fullscreen-change":_vm.onFullscreenChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }